import { Application } from '../../redux/appBuilder/appDetails/types';
import {
  EDIT_APPLICATION,
  GET_SIGNED_URL_FOR_APPLICATION_LOGO,
  REGISTER_NEW_APPLICATION,
  ZKFETCH_APPLICATION,
} from '../constants';
import { getFirebaseIdToken } from '../utils';

export const registerNewApplication = async (app: Application) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const response = await fetch(REGISTER_NEW_APPLICATION, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(app),
    });
    const data = await response.json();
    if (data.isSuccess) {
      return { isSuccess: true, app: data.app };
    }
  } catch (error) {
    console.log('something went wrong, couldnt register the application,', error);
    return { isSuccess: false };
  }
};

export const dataURLtoFile = (dataurl: string, filename: string): File => {
  const arr = dataurl.split(',');
  const mime = arr[0].match(/:(.*?);/)?.[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }

  return new File([u8arr], filename, { type: mime });
};

const uploadImageOnUrl = async (url: string, file: File, fileType: string) => {
  try {
    const uploadResponse = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': fileType,
      },
      body: file,
    });

    if (!uploadResponse.ok) {
      throw new Error('Failed to upload file');
    }

    return { error: null, url: url.split('?')[0] };
  } catch (error) {
    return { error: 'something went wrong while uploading image' };
  }
};

export const getSignedUploadUrlFromS3ForApplicationImage = async (
  address: string,
  file: File
) => {
  try {
    const fileType = file.type;
    const imageFormat = fileType?.split('/')[1];
    const fileName = `${address}.${imageFormat}`;
    const response = await fetch(GET_SIGNED_URL_FOR_APPLICATION_LOGO, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        fileName,
        fileType,
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to get pre-signed URL');
    }

    const { url } = await response.json();

    const data = await uploadImageOnUrl(url, file, fileType);
    return { ...data };
  } catch (error) {
    return { error: 'something went wrong while uploading image', url: '' };
  }
};

export const editApplication = async (app: Application) => {
  try {
    const accessToken = await getFirebaseIdToken();
    const response = await fetch(`${EDIT_APPLICATION(app.appId)}`, {
      method: 'PUT',
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(app),
    });
    const data = await response.json();
    if (data.isSuccess) {
      return { isSuccess: true, app: data.app };
    }
  } catch (error) {
    console.log('something went wrong, couldnt register the application,', error);
    return { isSuccess: false };
  }
};

export const getImageUrl = async (imageData: string, address: string) => {
  // convert base64 image to file type
  const imageFile = dataURLtoFile(imageData, 'image.jpg');
  const { error, url } = await getSignedUploadUrlFromS3ForApplicationImage(
    address,
    imageFile
  );
  if (error) {
    return { error: error };
  }

  return { url: url };
};

export const updateImageOnUrl = async (imageData: string, url: string) => {
  try {
    const imageFile = dataURLtoFile(imageData, 'image.jpg');
    const fileType = imageFile.type;
    const data = await uploadImageOnUrl(url, imageFile, fileType);
    return { ...data };
  } catch (error) {
    return { error: 'something went wrong while uploading image' };
  }
};

export const registerZkFetchApplication = async (app: Application) => {
  try {
    const accessToken = await getFirebaseIdToken();

    const { appId, name, description, projectName } = app;

    const response = await fetch(ZKFETCH_APPLICATION, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'authorization': `Bearer ${accessToken}`,
      },
      body: JSON.stringify({
        publicKey: appId,
        applicationName: name,
        projectName: projectName,
        description: description,
      }),
    });

    const data = await response.json();
    if (data.isSuccess) {
      return { isSuccess: true, app: data.app };
    }
  } catch (error) {
    console.log('something went wrong, couldnt register the application,', error);
    return { isSuccess: false };
  }
};
